import { apolloClient } from '@/graphql/apollo'
import listMailingsGql from '@/graphql/query/listMailingsGql.gql'

import {
  SET_MAILINGS
} from './types'

export const state = {
  entries: [],
}

export const mutations = {
  [SET_MAILINGS] (state, value) {
    state.entries = value
  }
}

export const actions = {
  fetchEntries ({ commit }, folderId) {
    apolloClient.query({
      query: listMailingsGql,
      fetchPolicy: 'no-cache',
      variables: {
        id: folderId
      }
    }).then(({ data }) => {
      commit(SET_MAILINGS, data['ListMailings'])
    })
    .catch(error => console.log(error))
  },
  resetEntries ({ commit }) {
    commit(SET_MAILINGS, [])
  },
}

export const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/mailings/mailings.js